<template>
  <notifications class="relative z-60" position="top center" group="donationWidget" ></notifications>
  <div class="px-10 flex flex-col h-full pb-10">    
    <div class="space-y-3">
      <p class="font-medium text-base mb-0 text-black">Personal Information</p>
      <p class="text-sm mb-0 text-gray-500">Please provide your details so we can contact you about your donation</p>
      <div class="grid grid-cols-6 gap-3 lg:gap-3">
        <div class="col-span-3">
          <label for="first-name" class="block text-sm text-gray-700 font-medium">First name</label>
          <input
            type="text"
            class="mt-1 block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
            :class="{' border-red-500': errors.includes('firstName') === true, 'border-gray-160': errors.includes('firstName') === false }"
            v-model="donationWidgetState.firstName"
            id="firstName"
            name="firstName"
            placeholder=""
          >
        </div>
        <div class="col-span-3">
          <label for="last-name" class="block text-sm text-gray-700 font-medium">Last name</label>
          <input
            type="text"
            :class="{' border-red-500': errors.includes('lastName') === true, 'border-gray-160': errors.includes('lastName') === false }"
            v-model="donationWidgetState.lastName"
            id="lastName"
            name="lastName"
            placeholder=""
            class="mt-1 block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
          >
        </div>
      </div>
      <div>
        <div class="col-span-12 sm:col-span-4">
          <label for="email-address" class="block text-sm text-gray-700 font-medium">Email address</label>
          <input 
            type="email"
            class="mt-1 block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
            :class="{' border-red-500': errors.includes('email') === true, 'border-gray-160': errors.includes('email') === false }"
            v-model="donationWidgetState.email"
            id="email"
            name="email"
            placeholder=""
          >
        </div>
      </div>
      <div class="grid grid-cols-6 gap-3 lg:gap-3">
        <div class="col-span-3 sm:col-span-2">
          <label for="city" class="block text-sm text-gray-700 font-medium">City</label>
          <input
            type="text"
            class="mt-1 block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
            :class="{' border-red-500': errors.includes('city') === true, 'border-gray-160': errors.includes('city') === false }"
            v-model="donationWidgetState.city"
            id="city"
            name="city"
            placeholder=""
          >
        </div>
        <div class="col-span-3 sm:col-span-2">
          <label for="state" class="block text-sm text-gray-700 font-medium">State</label>
          <select 
            class="mt-1 block w-full border-gray-200 py-2 pl-3 pr-3 text-base sm:text-sm focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
            :class="{' border-red-500': errors.includes('state') === true, 'border-gray-160': errors.includes('state') === false }"
            id="state"
            v-model="donationWidgetState.state"
            name="state"
          >
            <option v-for="option in options" v-bind:value="option">
              {{ option }}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-2">
          <label for="zip" class="block text-sm text-gray-700 font-medium">ZIP</label>
          <input
            v-maska data-maska="#####"
            type="text"
            class="mt-1 block w-full border-gray-200 sm:text-sm py-2 pl-3 pr-3 text-base focus:ring-0 border focus:border-gray-300 focus:outline-none rounded-md"
            :class="{' border-red-500': errors.includes('zip') === true, 'border-gray-160': errors.includes('zip') === false }"
            v-model="donationWidgetState.zip"
            id="zip"
            name="zip"
            placeholder=""
          >
        </div>
      </div>
      <div v-show="!donationWidgetState.hasDedication" class="relative flex pt-1">
        <div class="flex h-5 items-center">
          <input id="anonymousDonation" aria-describedby="anonymousDonation" name="anonymousDonation" type="checkbox" class="transition-all ease-in-out duration-300 h-4 w-4 border-gray-200 focus:ring-0 rounded-md" v-model="donationWidgetState.isAnonymous">
        </div>
        <div class="ml-3 text-sm">
          <label for="anonymousDonation" class="text-black font-normal text-sm lg:text-base">
            I would like to make this donation anonymously
          </label>
        </div>
      </div>
    </div>
    
    <fieldset class="mt-auto space-y-0">
      <button 
        @click.prevent="next" 
        class="transition-all ease-in-out duration-300 bg-pink-500 hover:bg-pink-700 text-white uppercase py-2 px-4 w-full font-semibold mt-2 rounded-full"
        :disabled="donationWidgetState.isProcessing"
        :class="{ 'opacity-50 cursor-not-allowed': donationWidgetState.isProcessing }"
      >
        <span v-if="!donationWidgetState.isProcessing">
          Donate <span class="currency-code">$</span><span>{{donationAmountForView}}</span>
        </span>
        <span v-else>
          Processing... <i class="fas fa-spinner fa-spin"></i>
        </span>
      </button>
    </fieldset>
    <fieldset class="mt-auto">
      <p 
        @click.prevent="back"
        class="text-black font-medium underline text-center cursor-pointer"
      >Back</p>
    </fieldset>
  </div>
  
</template>

<script>
  import BigNumber from 'bignumber.js'
  import { vMaska } from "maska"
  import mitt from 'mitt';
  
  const emitter = mitt();

  export default {
    name: 'contact-form',
    directives: { maska: vMaska },
    data() {
      return {
        errors: [],
        options: [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'FM', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ],
      }
    },

    computed: {
      calculatedFee() {
        const fixedFee = '30' // in cents
        const percentageFee = new BigNumber(0.022) // percentage
        const one = new BigNumber(1)
        const goal = new BigNumber(this.donationWidgetState.amount)
        const calculatedCharge = goal.plus(fixedFee).dividedBy(one.minus(percentageFee))
        return BigNumber(calculatedCharge.minus(goal))
      },
      
      calculatedTotal() {
        const amount = new BigNumber(this.donationWidgetState.amount)
        if (this.donationWidgetState.paidForTransactionFee) {
          return BigNumber(amount.plus(this.calculatedFee))
        }
        return amount
      },
      donationWidgetState() {
        return this.$store.getters.donationWidget
      },
      donationAmountForView() {
        return new BigNumber(this.calculatedTotal).dividedBy(100).toFormat(2)
      },
    },

    methods: {
      back() {
        this.donationWidgetState.enterFromDirection = '-translate-x-full'
        this.donationWidgetState.leaveToDirection = 'translate-x-full'
        
        this.donationWidgetState.steps.contact.isInView = false
        this.donationWidgetState.steps.payment.isInView = true
        return
      },
      async next() {
        if (this.donationWidgetState.isProcessing) {
          return;
        }
        
        this.donationWidgetState.isProcessing = true;
        this.errors = [];
        
        if (!this.donationWidgetState.firstName) {
          this.$notify({
            text: 'Please enter your first name',
            type: 'error',
            group: 'donationWidget',
          });
          this.errors.push('firstName');
          this.donationWidgetState.isProcessing = false;
          return;
        }
        
        if (!this.donationWidgetState.lastName) {
          this.$notify({
            text: 'Please enter your last name',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('lastName')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        if (!this.validEmail()) {
          this.$notify({
            text: 'Please enter a real email address',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('email')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        if (!this.donationWidgetState.email) {
          this.$notify({
            text: 'Please enter an email address',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('email')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        if (!this.donationWidgetState.city) {
          this.$notify({
            text: 'Please enter your city',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('city')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        if (!this.donationWidgetState.state) {
          this.$notify({
            text: 'Please select your state',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('state')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        // Regular expression for a 5-digit ZIP code
        var zipCodeRegex = /^\d{5}$/;
        
        if (!zipCodeRegex.test(this.donationWidgetState.zip)) {
         this.$notify({
           text: 'Please enter a valid ZIP code',
           type: 'error',
           group: 'donationWidget',
         })
         
         this.errors.push('zip')
         
         this.donationWidgetState.isProcessing = false
         
         return
        }
        
        if (!this.donationWidgetState.zip) {
          this.$notify({
            text: 'Please enter your ZIP Code',
            type: 'error',
            group: 'donationWidget',
          })
          
          this.errors.push('zip')
          
          this.donationWidgetState.isProcessing = false
          
          return
        }
        
        if (this.errors.length === 0) {
          try {
            const response = await axios.post('/api/donation-widget-payment', {
              team_id: 1,
              campaign_id: this.donationWidgetState.campaignId,
              pledge_id: this.donationWidgetState.pledgeId,
              amount: new BigNumber(this.calculatedTotal).toFixed(0),
              calculated_transaction_fee: this.calculatedFee.toFixed(0),
              paid_for_transaction_fee: this.donationWidgetState.paidForTransactionFee,
              payment_type_id: 1,
              payment_type_identifier: this.donationWidgetState.paymentIdentifier,
              business_name: this.donationWidgetState.businessName,
              address: '',
              is_anonymous: this.donationWidgetState.isAnonymous,
              occurrence: this.donationWidgetState.occurrence,
              double_the_donation: this.donationWidgetState.doubleTheDonation,
              token: this.donationWidgetState.paymentToken,
              has_dedication: this.donationWidgetState.hasDedication,
              in_memory_honor_of: this.donationWidgetState.hasDedication ? this.donationWidgetState.honoreeName : null,
              honoree_name: this.donationWidgetState.hasDedication ? this.donationWidgetState.honoreeName : null,
              honoree_email: this.donationWidgetState.hasDedication ? this.donationWidgetState.honoreeEmail : null,
              message_to_recipient: this.donationWidgetState.hasDedication ? this.donationWidgetState.honoreeMessage : null,
              selection: this.donationWidgetState.hasDedication ? this.donationWidgetState.inHonorOfSelection : null,
              first_name: this.donationWidgetState.firstName,
              last_name: this.donationWidgetState.lastName,
              email: this.donationWidgetState.email,
              city: this.donationWidgetState.city,
              state: this.donationWidgetState.state,
              zip: this.donationWidgetState.zip
            });
          
            // Handle success
            emitter.emit('campaign-donation-update', response.data.campaign);
            this.donationWidgetState.successfulTransactionData = response.data;
          
            this.donationWidgetState.steps.contact.isInView = false;
            this.donationWidgetState.steps.thankYou.isInView = true;
          } catch (reason) {
            if (reason.response && reason.response.data && reason.response.data.error) {
              const errorElement = document.getElementById('card-errors');
              errorElement.textContent = reason.response.data.error;
              this.$notify({
                text: reason.response.data.error,
                type: 'error',
                group: 'donationWidget',
              });
            } else {
              console.error(reason); // Log the error to the console for debugging
              this.$notify({
                text: 'An error occurred while processing your donation. Please try again.',
                type: 'error',
                group: 'donationWidget',
              });
            }
            // Add a small delay before allowing another submission attempt
            setTimeout(() => {
              this.donationWidgetState.isProcessing = false;
            }, 2000);
            return;
          }
        }
        
        // Only set isProcessing to false if we've reached this point (successful donation)
        this.donationWidgetState.isProcessing = false;
      },
      validEmail() {
        var re = /\S+@\S+\.\S+/;
        return re.test(this.donationWidgetState.email);
      },
    },
  }
</script>

<style scoped>

</style>
